import React, { Component, Fragment } from 'react'
import CenterElement from '../../activity/activityComponent/CenterElement'


class QuestionUI extends Component {

    render = () => {
        let { activity, quizViewer } = this.props
        let { quizViwerModel } = quizViewer.state
        let qImgSrc = quizViwerModel.imgRes + activity.tfQ.qImgSrc
        let { selectedStyle } = activity.tfQ
        return (
            <Fragment>
                <div style={{padding:"20px"}}
                // style={(selectedStyle)?selectedStyle[0].style:{}}
                >

                {(activity.tfQ.showImg) ?
                        <div 
                        // style={(selectedStyle)?selectedStyle[1].style:{}}
                        >
                            <table style={{ width: "100%", height: "100%" }} >
                                <tbody>
                                    <tr>
                                        <td style={{ textAlign: "center", verticalAlign: "middle",direction:"rtl" }}>
                                            <img src={qImgSrc} style={{ width: "100%" }} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                        : <></>}

                    {(activity.tfQ.showTxt) ?
                        <div 
                        // style={(selectedStyle)?selectedStyle[2].style:{}}
                        >
                            <CenterElement
                                content={activity.tfQ.qTxt}
                                style={{ fontSiz: "16px" }}
                                textAlign="center" />
                        </div>
                        : ''
                    }


                </div>
            </Fragment>
        )
    }
}

export default QuestionUI